import React from "react";
import styled, { css } from "styled-components";
import AntSegmented, { SegmentedProps } from "antd/es/segmented";

type NewLookSegmentedProps<T> = SegmentedProps<T> & {
  /** "large" is used for the billing period toggle. */
  variant?: "large";
};

/**
 * A pill-shaped segmented control for small toggles in the settings area
 * (new look).
 */
const NewLookSegmented = <T,>({
  variant,
  className,
  ...props
}: NewLookSegmentedProps<T>) => (
  <StyledSegmented
    className={className}
    $variant={variant}
    {...(props as SegmentedProps<unknown>)}
  />
);

export default NewLookSegmented;

/**
 * The track, thumb, colours and weights come from the central new-look
 * segmented rules (styles/newLook.scss); this only sizes the control.
 */
const StyledSegmented = styled(AntSegmented)<{ $variant?: "large" }>`
  .ant-segmented-item-label {
    min-height: 28px;
    line-height: 28px;
    padding: 0 14px;
    font-size: 13px;
  }
  ${(p) =>
    p.$variant === "large" &&
    css`
      &.ant-segmented {
        padding: 3px;
      }
      .ant-segmented-item-label {
        min-height: 34px;
        line-height: 34px;
        padding: 0 22px;
        font-size: 14px;
      }
    `}
`;
